{
  "cashier": "Kassa",
  "depositTab": "Depozit",
  "withdrawTab": "Çıxarış",
  "historyTab": "Tarixçə",
  "secureNote": "",
  "selectMethod": "Ödəniş üsulu seçin",
  "amount": "Məbləğ",
  "amountPlaceholder": "Məbləği daxil edin",
  "quickAmounts": "Sürətli məbləğ",
  "continue": "Davam etmək",
  "depositNow": "Depozit et",
  "withdrawNow": "Çıxarış sorğusu",
  "methodDisabled": "Bu üsul hələ aktiv deyil",
  "methodsPending": "Ödəniş rekvizitləri admin tərəfindən konfiqurasiya edilməyib",
  "receiptRequired": "Qəbz yükləməsi tələb olunur — qəbz ödənişin təsdiqi deyil",
  "adminVerification": "Köçürməni tamamladıqdan sonra ödəniş qəbzini yükləyin.",
  "noCryptoNetworks": "Kripto şəbəkələri konfiqurasiya edilməyib",
  "noAddress": "Depozit ünvanı hələ təyin olunmayıb",
  "cardToCard": "Kart-kart",
  "cardToCardDesc": "Bank kartına köçürmə",
  "m10": "M10",
  "m10Desc": "M10 köçürməsi",
  "terminal": "Terminal",
  "terminalDesc": "Terminal ödənişi",
  "crypto": "Kriptovalyuta",
  "cryptoDesc": "Kripto depozit",
  "bankCardWithdraw": "Bank kartı",
  "m10Withdraw": "M10",
  "cryptoWithdraw": "Kripto",
  "minMax": "Min {{min}} — Max {{max}}",
  "trustInstant": "Sürətli emal (konfiqurasiya edildikdə)",
  "trustSecure": "Təhlükəsiz əməliyyatlar",
  "trustMethods": "Kart-kart, M10, Terminal, Kripto",
  "historyEmpty": "Tranzaksiya yoxdur",
  "historyAuth": "Tarixçə üçün giriş lazımdır",
  "balanceTitle": "Balans",
  "openCashier": "Pulqabı",
  "topUp": "Hesabı artırmaq",
  "bonusAccount": "Bonus hesabı",
  "reservedFunds": "Rezerv olunmuş",
  "copyId": "ID-mi kopyala",
  "loginRequired": "Davam etmək üçün giriş edin",
  "region": "Ödəniş regionu",
  "instructionsSoon": "Rekvizit təyin olunandan sonra təlimatlar burada görünəcək",
  "uploadReceipt": "Qəbz yüklə",
  "uploadDisabled": "Depozit sorğusu yaradılmadan qəbz qəbul edilmir",
  "depositCreated": "Depozit sorğusu yaradıldı",
  "receiptUploaded": "✅ Qəbz uğurla yükləndi! Ödəniş sorğunuz qeydə alındı. Zəhmət olmasa, gözləyin.",
  "withdrawReserved": "Çıxarış rezerv olundu",
  "destination": "Alıcı məlumatı",
  "destinationRequired": "Alıcı məlumatını daxil edin",
  "noCvv": "CVV və PIN tələb olunmur və qəbul edilmir",
  "status": "Status",
  "copy": "Kopyala",
  "bankPayment": "Bank ödənişi",
  "currentBalance": "Cari balansınız: {{amount}}",
  "copied": "Kopyalandı",
  "selectCoin": "Coin",
  "selectNetwork": "Şəbəkə",
  "timeRemaining": "Qalan vaxt",
  "depositExpired": "Bu depozit sorğusunun vaxtı bitdi. Yenisini yaradın.",
  "cancelDeposit": "Sorğunu ləğv et",
  "qrLabel": "Depozit ünvanının QR kodu",
  "copyAddress": "Ünvan",
  "cardHolder": "Kart sahibinin adı və soyadı",
  "sendExactAmount": "Göstərilən məbləği dəqiq göndərin. Yanlış şəbəkə və ya məbləğ kredit olunmur.",
  "noPairsConfigured": "Coin/şəbəkə cütü hələ konfiqurasiya edilməyib",
  "depositCancelled": "Depozit sorğusu ləğv edildi",
  "usdRate": "1 USD = {{rate}} AZN",
  "minUsd": "Min ${{usd}}",
  "saveQr": "QR-i yadda saxla",
  "networkWarning": "Yalnız {{network}} şəbəkəsinə göndərin. Səhv şəbəkə vəsaitin itirilməsinə səbəb ola bilər.",
  "filter_all": "Hamısı",
  "filter_deposit": "Depozit",
  "filter_withdrawal": "Çıxarış",
  "field_card_number": "Kart nömrəsi",
  "field_card_holder": "Kart sahibi",
  "field_bank_name": "Bank",
  "field_m10_account": "M10 hesabı",
  "field_account_holder": "Hesab sahibi",
  "field_terminal_code": "Terminal kodu",
  "field_address": "Ünvan",
  "field_asset": "Coin",
  "field_network": "Şəbəkə",
  "field_memo": "Memo",
  "field_phone": "Telefon",
  "field_iban": "IBAN",
  "field_name": "Ad",
  "methodSelected_card_to_card": "Kartdan karta ödəniş seçildi",
  "methodSelected_m10": "M10 ilə ödəniş seçildi",
  "methodSelected_terminal": "Terminal ilə ödəniş seçildi",
  "methodSelected_crypto": "Kriptovalyuta seçildi",
  "cryptoUnavailable": "Kriptovalyuta depoziti hazır deyil",
  "cryptoUnavailableHint": "Qəbul ünvanı və şəbəkə admin tərəfindən təyin olunmayıb. Real vəsait göndərməyin — saxta ünvan göstərilmir.",
  "quotePreview": "Kotirovka",
  "expectedCredit": "Gözlənilən AZN kredit",
  "estimatedCrypto": "Təxmini kripto məbləği",
  "adminRateNote": "Bu məzənnə admin tərəfindən təyin olunub, canlı bazar qiyməti deyil.",
  "enterAmountFirst": "Əvvəlcə məbləği daxil edin, sonra coin və şəbəkəni seçin.",
  "status_waiting_for_payment": "Ödəniş gözlənilir",
  "status_detected": "Köçürmə aşkarlandı",
  "status_awaiting_confirmations": "Təsdiqlər gözlənilir",
  "status_confirmed": "Təsdiqləndi",
  "status_expired": "Vaxt bitib",
  "status_ambiguous": "Əl ilə yoxlama tələb olunur",
  "status_error": "Xəta / dəstəklənməyən",
  "status_pending_review": "Yoxlama gözlənilir",
  "status_cancelled": "Ləğv edilib",
  "status_rejected": "Rədd edilib",
  "status_approved": "Təsdiqləndi",
  "expiredLateNote": "Vaxt bitdikdən sonra blokçeyn köçürməsi gələ bilər. O, avtomatik kredit olunmur və izlənilən yoxlama tələb edir.",
  "enlargeQr": "QR-i böyüt",
  "closeQr": "Bağla",
  "confirmationTimeNote": "10 dəqiqəlik taymer sorğunun gözləmə müddətidir, blokçeyn təsdiqi deyil.",
  "usdEquivalent": "USD ekvivalenti: ${{usd}}",
  "quoteUnavailable": "Kotirovka alınmadı. Məbləğ və şəbəkəni yoxlayın.",
  "depositRequests": "Depozit sorğuları",
  "networkMismatch": "Yalnız göstərilən şəbəkəyə göndərin.",
  "safeRecovery": "Əlaqə kəsildi. Son saxlanmış sorğu bərpa olunacaq.",
  "historyAll": "Hamısı",
  "historyDeposit": "Depozit",
  "historyWithdrawal": "Çıxarış",
  "historyEmptyTitle": "Əməliyyat tarixçəsi boşdur",
  "historyEmptyDescription": "Depozit və çıxarış sorğularınız burada göstəriləcək.",
  "historyBankDeposit": "Bank depoziti",
  "statusPending": "Gözlənilir",
  "statusReview": "Yoxlanılır",
  "statusApproved": "Təsdiqləndi",
  "statusPaid": "Ödənildi",
  "statusCompleted": "Tamamlandı",
  "statusRejected": "İmtina edildi",
  "statusExpired": "Vaxtı bitdi",
  "statusCancelled": "Ləğv edildi",
  "statusFailed": "Uğursuz oldu",
  "withdrawAcceptedClean": "Çıxarış sorğunuz qəbul edildi və yoxlanışa göndərildi.",
  "selectBankLocal": "Bankı seçin",
  "holderFullNameLocal": "Kart sahibinin adı və soyadı",
  "recipientCardLocal": "Kart nömrəsi",
  "availableBalanceLocal": "Çıxarıla bilən balans",
  "backWithdrawalLocal": "Geri — çıxarış üsulları",
  "withdrawDetailsLocal": "Çıxarış məlumatlarını doldurun",
  "paymentMethodsLocal": "Ödəniş üsulları",
  "paymentAmountLocal": "Ödəniş məbləği",
  "transactionTypeLocal": "Əməliyyat növü",
  "walletSectionsLocal": "Pulqabı bölmələri",
  "cryptoTransferTitle": "Kriptovalyuta ödənişi",
  "cryptoTransferAmount": "Göndəriləcək məbləğ",
  "cryptoOrderAmount": "Sifariş məbləği",
  "cryptoTransferAddress": "Pulqabı ünvanı",
  "cryptoTransferNetwork": "Şəbəkə",
  "cryptoShowQr": "QR kodu aç",
  "cryptoQrWaiting": "QR kod hazır deyil",
  "cryptoNoAddress": "Ünvan mövcud deyil. Köçürmə etməyin.",
  "cryptoWarnNetwork": "Yalnız {{asset}} valyutasını {{network}} şəbəkəsi ilə göndərin. Yanlış şəbəkə ilə köçürülən vəsait itirilə bilər.",
  "cryptoWarnAmount": "Göndəriləcək məbləği və şəbəkə komissiyasını diqqətlə yoxlayın. Kifayət etməyən köçürmə qəbul olunmaya bilər.",
  "cryptoMoreInfo": "Əlavə ödəniş məlumatı",
  "cryptoMemo": "Memo / Tag",
  "prevStep": "Əvvəlki mərhələ",
  "depositAmount": "Depozit məbləği",
  "paymentInstruction": "Ödəniş təlimatı",
  "paymentConfirm": "Ödəniş təsdiqi",
  "depositStages": "Depozit mərhələləri",
  "stageAmount": "Məbləğ",
  "stagePayment": "Ödəniş",
  "stageReceipt": "Çek",
  "receiptSend": "Çek göndərilməsi",
  "rejected": "İmtina edildi",
  "network": "Şəbəkə",
  "paymentNote": "Ödəniş qeydi",
  "extraPaymentInfo": "Əlavə ödəniş məlumatı",
  "invalidAmount": "Düzgün məbləğ daxil edin.",
  "tapToSelect": "Seçmək üçün toxunun",
  "walletLabel": "Pulqabı",
  "previewBanner": "SINAQ REJİMİ: Bütün ödəniş kartları seçilə bilər. Real pul göndərməyin; depozit və çıxarış icra olunmur.",
  "otherBank": "Digər bank",
  "cryptoAsset": "Kriptovalyuta",
  "receiveAddress": "Qəbul ünvanı",
  "notAssigned": "Təyin edilməyib",
  "paymentMethod": "Ödəniş üsulu",
  "bank": "Bank",
  "recipient": "Alıcı",
  "cardNumber": "Kart nömrəsi",
  "qrWhenReady": "QR kod yalnız real ünvan mövcud olduqda göstəriləcək",
  "qrInactive": "QR kod aktiv deyil",
  "qrInactiveHint": "Qəbul ünvanı təyin ediləndə burada göstəriləcək.",
  "networkAttention": "Diqqət: {{network}} şəbəkəsi",
  "networkAttentionBody": "Yalnız seçdiyiniz şəbəkəyə uyğun ünvana köçürün. Yanlış şəbəkə və ya məbləğ vəsaitin itirilməsinə səbəb ola bilər.",
  "minDepositFees": "Minimum depozit və komissiya",
  "minDepositFeesBody": "Minimum məbləği və şəbəkə komissiyasını göndərməzdən əvvəl yoxlayın. Qəbul ünvanı olmadan köçürmə etməyin.",
  "waitingTransfer": "Köçürmənizi gözləyirik",
  "waitingTransferBody": "Yalnız təsdiqlənmiş alıcı rekvizitlərinə, göstərilən dəqiq məbləğdə ödəniş edin.",
  "wrongTransfer": "Yanlış köçürmələr barədə",
  "wrongTransferBody": "Başqa banka, yanlış karta və ya fərqli məbləğdə göndərilən ödəniş hesabınıza daxil olmaya bilər.",
  "previewNoAddress": "SINAQ REJİMİ · ÖDƏNİŞ ÜNVANI VERİLMƏYİB · PUL GÖNDƏRMƏYİN",
  "addReceiptTitle": "Ödəniş qəbzini əlavə edin",
  "addReceiptBody": "Ödəniş qəbzini kamera ilə çəkə, qalereyadan seçə və ya fayl əlavə edə bilərsiniz. Sınaq rejimində fayl serverə göndərilmir.",
  "cameraCapture": "Kamera ilə çək",
  "sampleTimer": "Nümunə müddət — real sorğu yaradılmayıb",
  "transferDetails": "Köçürmə məlumatları",
  "paymentDetailsStep": "Ödəniş məlumatları",
  "paymentConfirmStep": "Ödəniş təsdiqi",
  "iPaidReceipt": "Mən ödədim · Çek ekranı",
  "fromGallery": "Qalereyadan seç",
  "chooseFile": "Fayl seç",
  "cameraFileSelected": "Kamera faylı seçildi: {{name}}. Sınaq rejimində serverə yüklənmir.",
  "imageSelected": "Şəkil seçildi: {{name}}. Sınaq rejimində serverə yüklənmir.",
  "fileSelected": "Fayl seçildi: {{name}}. Sınaq rejimində serverə yüklənmir.",
  "previewTest": "Sınaq",
  "fileNotUploaded": "Fayl serverə yüklənmir",
  "bankSelect": "Bank seçimi",
  "depositBonusSample": "Depozit bonusu · nümunə",
  "checkFinalAmount": "Son ödəniş məbləğini yaradılmış sifarişdə yoxlayın.",
  "cryptoAwaitingAdmin": "Kripto köçürmədən sonra çek yükləməyə ehtiyac yoxdur. Admin blockchain əməliyyatını yoxlayıb təsdiqləyəcək; yalnız bundan sonra balans artırılacaq.",
  "err_asset_quote_missing": "Seçilmiş kriptovalyuta üçün məzənnə yoxdur. Bir az sonra yenidən yoxlayın və ya digər aktiv seçin.",
  "err_asset_quote_stale": "Kripto məzənnəsi köhnəlib. Yenilənməni gözləyin və yenidən cəhd edin.",
  "err_gram_min_not_met": "GRAM üçün minimum depozit 2 GRAM-dır.",
  "err_amount_out_of_limits": "Məbləğ icazə verilən limitlərdən kənardır.",
  "err_no_active_requisite": "Bu aktiv/şəbəkə üçün qəbul ünvanı hələ konfiqurasiya olunmayıb.",
  "err_unsupported_crypto_pair": "Bu aktiv və şəbəkə cütü dəstəklənmir.",
  "err_receipt_not_required_for_crypto": "Kripto depozitdə çek tələb olunmur.",
  "err_asset_feed_unavailable": "Kripto məzənnə mənbəyi əlçatan deyil.",
  "orderNumber": "Sifariş nömrəsi:",
  "amountDue": "Ödəniləcək məbləğ:",
  "requestProcessing": "Sorğu emal olunur",
  "paymentCreated": "Ödəniş sorğunuz uğurla yaradıldı!",
  "completeTransferHint": "Zəhmət olmasa, aşağıdakı ödəniş məlumatlarından istifadə edərək köçürməni tamamlayın.",
  "exactAmountWarn": "Diqqət! Yalnız göstərilən məbləği göndərin və düzgün ödəniş məlumatlarından istifadə edin.",
  "uploadReceiptAfter": "Köçürməni tamamladıqdan sonra ödəniş qəbzini yükləyin.",
  "paymentInfo": "Ödəniş məlumatları",
  "cardHolderName": "Kart sahibinin adı",
  "receiverName": "Qəbul edənin adı",
  "accountNumber": "Hesab nömrəsi",
  "previewDepositSelected": "SINAQ REJİMİ: {{method}} — {{amount}} AZN seçildi. Real depozit yaradılmadı, pul göndərməyin.",
  "previewWithdrawChecked": "SINAQ REJİMİ: {{method}} üzrə {{amount}} AZN çıxarış yoxlandı. Heç bir real sorğu yaradılmadı.",
  "checkingFileSelection": "Fayl seçimini yoxlayırsınız",
  "bonusSampleLine": "5%: {{bonus}} · yekun: {{total}}",
  "phoneNumber": "Telefon nömrəsi",
  "addressLabel": "ünvanı",
  "uploadReceiptReminder": "Ödənişi tamamladıqdan sonra qəbzinizi yükləməyi unutmayın.",
  "previewWithdrawBanner": "SINAQ REJİMİ: Real çıxarış göndərilmir və balans dəyişmir.",
  "cardExpiry": "Kartın istifadə müddəti (Ay/İl)",
  "checkRequest": "Sorğunu yoxla",
  "bonusNotOnReal": "Real balansda hesablanmır.",
  "tonConnectTitle": "TON Connect · GRAM",
  "tonConnectWallet": "TON pulqabını əlaqələndirin",
  "tonPayConfirm": "Ödənişi pulqabıda təsdiqləyin",
  "tonDisconnectWallet": "Pulqabı bağlantısını kəs",
  "tonWalletStatus": "Pulqabı vəziyyəti",
  "tonWalletNotConnected": "Qoşulmayıb",
  "tonWalletConnected": "Qoşulub · {{address}}",
  "tonWalletConnectedHint": "TON pulqabınız uğurla əlaqələndirildi.",
  "tonWalletDisconnected": "Pulqabı bağlantısı kəsildi.",
  "tonWalletConnectFailed": "Pulqabı bağlantısı alınmadı.",
  "tonConnectWalletFirst": "Əvvəl TON pulqabısını əlaqələndirin.",
  "tonConfirmInWallet": "Ödənişi pulqabınızda təsdiqləyin.",
  "tonPendingAdminReview": "Depozit sorğunuz yaradılıb. Ödəniş administrator tərəfindən yoxlanılır.",
  "tonDepositCreated": "TON depozit sorğusu yaradıldı. Pulqabı ilə ödənişi tamamlayın.",
  "tonPaymentCancelled": "Ödəniş ləğv edildi və ya tamamlanmadı.",
  "tonPaymentMissing": "Ödəniş məlumatı tapılmadı. Yenidən cəhd edin.",
  "tonPaymentProofMissing": "Pulqabı ödəniş sübutu qaytarmadı. Ödəniş tamamlanmayıbsa, yenidən cəhd edin.",
  "tonWarnNativeOnly": "Yalnız rəsmi GRAM jetton göndərin (master EQC47093…). Native TON və ya saxta GRAM* tokenlər qəbul edilmir.",
  "tonWarnAdminReview": "Pulqabı təsdiqi balans artımı demək deyil. Admin real köçürməni yoxladıqdan sonra balans artırılacaq.",
  "realBalance": "Real balans",
  "gameCurrencies": "Oyun valyutaları",
  "walletCta": "Pulqabı",
  "closeGameFirst": "Aktiv oyunda açıq mərc var. Oyunu bağlayıb sonra valyutanı dəyişin.",
  "regionLabel": "Ödəniş regionu",
  "regionCryptoOnly": "Bu regionda yalnız kriptovalyuta ödənişləri əlçatandır",
  "gameCurrency": "Oyun valyutası",
  "tonWarnGramJettonOnly": "Yalnız rəsmi GRAM jetton göndərin (master EQC47093…). Native TON və ya saxta GRAM* tokenlər qəbul edilmir.",
  "tonPayConfirmGram": "GRAM jetton ödənişini pulqabıda təsdiqləyin",
  "tonJettonMaster": "GRAM jetton kontraktı",
  "tonGramWalletMissing": "Bu pulqabıda GRAM jetton tapılmadı. Əvvəl GRAM əlavə edin və ya ünvan/QR ilə köçürün.",
  "tonGramConnectUnavailable": "TON Connect ilə GRAM göndərmə müvəqqəti deaktivdir. Ünvan və QR ilə depozit aktivdir."
}
